var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.410023 2.4519L5.84896 8.00716L0.410023 13.5624C-0.136674 14.1208 -0.136674 15.0228 0.410023 15.5812C0.95672 16.1396 1.83985 16.1396 2.38654 15.5812L8.82075 9.0094C9.36744 8.45101 9.36744 7.54899 8.82075 6.9906L2.38654 0.418793C1.83985 -0.139597 0.95672 -0.139597 0.410023 0.418793C-0.122656 0.977181 -0.136674 1.89351 0.410023 2.4519Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.59 13.5481L10.151 7.99284L15.59 2.43758C16.1367 1.87919 16.1367 0.977181 15.59 0.418792C15.0433 -0.139597 14.1602 -0.139597 13.6135 0.418792L7.17925 6.9906C6.63256 7.54899 6.63256 8.45101 7.17925 9.0094L13.6135 15.5812C14.1602 16.1396 15.0433 16.1396 15.59 15.5812C16.1227 15.0228 16.1367 14.1065 15.59 13.5481Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.ac1e7bc8.svg";
export { ForwardRef as ReactComponent };